module.exports = __webpack_public_path__ + "4d06057d5ae9f3efd45d8f56d7898dbf.woff";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/content/fonts/ArialMT-Bold.woff
// module id = 359
// module chunks = 1